module.exports = __webpack_public_path__ + "img/logoAUG.d41da821.png";